import { render } from "./OlapSortingDialog.vue?vue&type=template&id=0d4e946c&ts=true"
import script from "./OlapSortingDialog.vue?vue&type=script&lang=ts"
export * from "./OlapSortingDialog.vue?vue&type=script&lang=ts"

import "./OlapSortingDialog.vue?vue&type=style&index=0&id=0d4e946c&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__